<et-step-layout [data]="data">
  <div class="flex align-items-center justify-content-between">
    <div class="w-9">
      <p class="title3Font mt-0"
         i18n>References</p>
      @if (!isReadonly) {
        <p class="body2Font"
           i18n>The number of verified references can be increased by preparing them in accordance with our
          template.
          Please, re-upload the file and 'Reload' references to be verified. You will be able to go to the next
          submission step after
          approving references</p>
      }
    </div>
    @if (!isReadonly) {
      <div>
        <p-button (onClick)="reupload()"
                  label="Reupload references"
                  i18n-label
                  styleClass="p-button-outlined">
        </p-button>
      </div>
    }
  </div>

  <div>
    @if (tableSettings) {
      <p-table [scTableSettings]="tableSettings">
      </p-table>
    }
  </div>
</et-step-layout>